import { createRootRouteWithContext, Link, Outlet } from '@tanstack/react-router';

import type { RouterContext } from '@/app/router';
import { UpdatePrompt } from '@/components/shell/banners';
import { Button } from '@/components/ui/button';
import { Toaster } from '@/components/ui/sonner';
import { useDirection, useT } from '@/i18n/react';

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootLayout,
  notFoundComponent: NotFound,
});

function RootLayout() {
  const dir = useDirection();
  return (
    <>
      <Outlet />
      <Toaster position={dir === 'rtl' ? 'bottom-left' : 'bottom-right'} dir={dir} />
      <UpdatePrompt />
    </>
  );
}

function NotFound() {
  const t = useT();
  return (
    <main className="public-login-page min-h-dvh">
      <div className="public-login-card">
        <div className="eyebrow">404</div>
        <h1 className="page-title">{t('Page not found')}</h1>
        <p className="page-subtitle">
          {t('The page you are looking for does not exist or has moved.')}
        </p>
        <Button asChild variant="field" className="mt-6">
          <Link to="/home">{t('Go home')}</Link>
        </Button>
      </div>
    </main>
  );
}
